export default "__VITE_ASSET__DeK13jwZ__"